<main class="auth-shell">
	<section class="panel auth-copy">
		<h1>Save the deployment before launch.</h1>
		<p class="hero-lede">
			Create your App Launcher account so you can come back anytime to
			manage your app, review updates, and keep your launch moving.
		</p>
		<div class="account-benefits">
			<article>
				<strong>Secure source access</strong
				><span>Connect GitHub after your account is ready.</span>
			</article>
			<article>
				<strong>One place to manage apps</strong
				><span
					>Create your first app, view deployments, and request more
					capacity.</span
				>
			</article>
		</div>
	</section>

	<section class="panel auth-card">
		<ng-container *ngIf="showingResetConfirm">
			<div class="password-reset-heading">
				<h2>Set a new password</h2>
				<p>Choose a new password for your App Launcher account.</p>
			</div>
			<form (ngSubmit)="confirmReset()">
				<div class="field">
					<label for="new-password">New password</label>
					<input
						id="new-password"
						name="newPassword"
						type="password"
						[ngModel]="password"
						(ngModelChange)="password = $event"
						(input)="onNewPasswordInput($event)"
						autocomplete="new-password"
						minlength="8"
						required
					/>
				</div>
				<p *ngIf="error" class="form-error" role="alert">{{ error }}</p>
				<button
					class="primary-button wide"
					type="submit"
					[disabled]="busy"
				>
					Set new password
				</button>
			</form>
		</ng-container>

		<ng-container *ngIf="showingResetRequest">
			<button
				class="back-link auth-back-link"
				type="button"
				(click)="backToSignIn()"
			>
				Back to sign in
			</button>
			<div
				*ngIf="resetSent"
				class="password-reset-confirmation"
				role="status"
			>
				<span class="status-badge success">Email sent</span>
				<h2>Check your email.</h2>
				<p>
					We sent a password reset link to
					<strong>{{ resetEmail }}</strong
					>.
				</p>
				<button
					class="primary-button wide"
					type="button"
					(click)="backToSignIn()"
				>
					Return to sign in
				</button>
			</div>
			<ng-container *ngIf="!resetSent">
				<div class="password-reset-heading">
					<h2>Reset your password</h2>
					<p>
						Enter your email and we’ll send you a password reset
						link.
					</p>
				</div>
				<form (ngSubmit)="sendResetLink()">
					<div class="field">
						<label for="reset-email">Email</label>
						<input
							id="reset-email"
							name="resetEmail"
							type="email"
							[value]="resetEmail"
							(input)="onResetEmailInput($event)"
							autocomplete="email"
							required
						/>
					</div>
					<p *ngIf="error" class="form-error" role="alert">
						{{ error }}
					</p>
					<button
						class="primary-button wide"
						type="submit"
						[disabled]="busy"
					>
						Send reset link
					</button>
				</form>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="!showingResetConfirm && !showingResetRequest">
			<div class="mode-tabs" role="tablist" aria-label="Account mode">
				<button
					[class.active]="state.accountMode === 'sign-in'"
					type="button"
					(click)="setMode('sign-in')"
				>
					Sign in
				</button>
				<button
					[class.active]="state.accountMode === 'create'"
					type="button"
					(click)="setMode('create')"
				>
					Create account
				</button>
			</div>
			<p *ngIf="state.sessionNotice" class="form-notice" role="status">
				{{ state.sessionNotice }}
			</p>
			<p>{{ copy }}</p>
			<button
				class="google-button"
				type="button"
				(click)="google()"
				[disabled]="busy"
			>
				Continue with Google
			</button>
			<div class="divider"><span>or use email</span></div>
			<form (ngSubmit)="submit()">
				<div class="field">
					<label for="email">Email</label>
					<input
						id="email"
						name="email"
						type="email"
						[(ngModel)]="email"
						autocomplete="email"
						required
					/>
				</div>
				<div class="field">
					<div class="password-label-row">
						<label for="password">Password</label>
						<button
							*ngIf="state.accountMode === 'sign-in'"
							class="forgot-password-link"
							type="button"
							(click)="openForgotPassword()"
						>
							Forgot password?
						</button>
					</div>
					<input
						id="password"
						name="password"
						type="password"
						[(ngModel)]="password"
						autocomplete="current-password"
						required
					/>
				</div>
				<p *ngIf="error" class="form-error" role="alert">{{ error }}</p>
				<button
					class="primary-button wide"
					type="submit"
					[disabled]="busy"
				>
					{{
						state.accountMode === 'sign-in'
							? 'Sign in and continue'
							: 'Create account and continue'
					}}
				</button>
			</form>
		</ng-container>
	</section>
</main>
